import compact from 'lodash/compact'
import map from 'lodash/map'
import React, { FC } from 'react'

import { Loading } from '@Components/CMS/Loading'
import { PreviouslySeenProducts } from '@Components/CMS/PreviouslySeenProducts'
import { ProductTileProps } from '@Domains/Product/Tiles/types'
import { useProductRecommendationsQuery } from '@Generated/graphql'
import { cmsProductToGridProduct } from '@Globals/CMS/ProductHelpers'

interface PreviouslySeenProductsBlockProps {
  id?: string
}

const PreviouslySeenProductsBlock: FC<PreviouslySeenProductsBlockProps> = ({ id }) => {
  const {
    data,
    error,
    loading,
  } = useProductRecommendationsQuery({
    context: {
      userSpecific: true,
    },
  })
  if (loading) {
    return (
      <Loading height={280} id={id} width="medium" />
    )
  }

  if (error) {
    return null
  }

  const products: ProductTileProps[] = compact(map(
    data?.userRecommendations?.products,
    x => cmsProductToGridProduct(x),
  ))

  if (!products.length) {
    return null
  }

  return (
    <PreviouslySeenProducts id={id} products={products} />
  )
}

export default PreviouslySeenProductsBlock
